import { S3_BRAND_MEDIA_BUCKET_LINK } from 'constants/links';
import { THUMBNAIL_HEIGHT } from '../InfiniteGrid/InfiniteGrid.config';

interface SerializeLogoDataProps {
  data: string[];
}

/**
 * Standardize the logo data from brand to a data format that can be used by the react-window variable grid
 * to correctly render a cell in the grid,
 * we will need the tags for a image, a url of the image, and the height of the image
 *
 * @param {object} props
 * @param {string[]} props.data a list of file names from the E1 end-point
 * @returns a array
 */
export const serializeLogoData = ({ data }: SerializeLogoDataProps) => {
  return data.map((fileName) => ({
    previewHeight: THUMBNAIL_HEIGHT,
    tags: fileName,
    previewURL: `${S3_BRAND_MEDIA_BUCKET_LINK}/${fileName}`,
  }));
};
